import React from 'react';
import { Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { OrderPageTypography } from '../themedComponents/OrderPageTypography';
import { customerFacingPriceFormatter } from '../utils';
import { OrderPageIntent } from '../OrderPageIntent';
import { usePriceExplanation } from '../hooks/usePriceExplanation';
import { useOrderPage } from '../orderPageContext/useOrderPage';
import { useIntentConfig } from '../intentConfig/useIntentConfig';
import { useLanguage } from '../../utils/GeneralUtils';
import { withBookingFee } from '../core/pricing';

/**
 * Without this the widget names no price until below the calendar — past the hero image and the
 * account's description, which on a phone is well over two screens of scrolling.
 */
export const HeadlinePrice = () => {
  const { t } = useTranslation();
  const { orderPageState } = useOrderPage();
  const { currentStepIndex } = useIntentConfig();
  const { orderPageIntent } = orderPageState;
  const { fromPerPerson, isFromPrice, unitLabel } = usePriceExplanation();
  const language = useLanguage();

  const shouldShow =
    currentStepIndex === 0 &&
    orderPageIntent !== OrderPageIntent.REDEEM_GIFT_CARD &&
    orderPageIntent !== OrderPageIntent.BUY_PASS &&
    !!fromPerPerson &&
    !orderPageState.isWalkIn;

  if (!shouldShow) {
    return null;
  }

  const price = customerFacingPriceFormatter(
    withBookingFee(fromPerPerson, orderPageState.account),
    orderPageState.account,
  ) as string;
  const unit = unitLabel?.[language];

  return (
    <Grid container justifyContent="center">
      <OrderPageTypography variant="h3" style={{ opacity: 0.75, textAlign: 'center', width: '100%' }}>
        {unit
          ? t(isFromPrice ? 'order_page.pricePerUnitFrom' : 'order_page.pricePerUnit', { price, unit })
          : t(isFromPrice ? 'order_page.pricePerParticipantFrom' : 'order_page.pricePerParticipant', { price })}
      </OrderPageTypography>
    </Grid>
  );
};
